export default __webpack_public_path__ + "static/media/waterCrackers.6dfa33ba.jpg";